module.exports = __webpack_public_path__ + "static/media/poing.ea989b13.mp3";